module.exports = __webpack_public_path__ + "img/mobile-import-drawer.fcd69dcc.svg";